import { render, staticRenderFns } from "./GroupTabMarketPlaceCard.vue?vue&type=template&id=40804952&scoped=true&"
import script from "./GroupTabMarketPlaceCard.vue?vue&type=script&lang=js&"
export * from "./GroupTabMarketPlaceCard.vue?vue&type=script&lang=js&"
import style0 from "./GroupTabMarketPlaceCard.vue?vue&type=style&index=0&id=40804952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40804952",
  null
  
)

export default component.exports